// @flow
import { combineReducers } from 'redux';
import { reducer as form } from 'redux-form';
import { createReducer } from 'redux-orm';

import type { State as ParcelState } from './searchCollections';
import searchParcels from './searchCollections';
import orm from '../orm/orm';

export type State = {|
  searchParcels: ParcelState,
|};

export default combineReducers<*, *>({
  form,
  searchParcels,
  orm: createReducer(orm),
});
